import React from 'react'
import system from 'system-components'
import flatten from 'ramda/src/flatten'
import { Fragment, Component, Icon, ActiveContent } from 'components'

const TocLink = system(
  {
    is: 'a',
  },
  'space',
  'color'
).extend`
  display: block;
`

const pointerStyle = {
  position: 'absolute',
  left: '10px',
  top: '-4px',
  fontSize: '1.5em',
}

const headingLevelMargins = [0, 0, 20, 40, 60, 80]
class Toc extends Component {
  constructor ({ toc }) {
    super()
    this.state = {
      toc,
    }
  }
  shouldComponentUpdate (nextProps) {
    return nextProps.toc !== this.state.toc
      || nextProps.activeId !== this.props.activeId
  }
  render () {
    const { level=0 } = this.props
    return this.state.toc.map(heading => (
      <Fragment key={heading.id}>
        <TocLink mt={3} ml={`${headingLevelMargins[level]}px`} href={`#${heading.id}`}>
          {level >= 2 && <Icon name="circle" mr={2} style={{ verticalAlign: 'middle' }} size=".6em" />}
          {heading.title}
          {heading.id === this.props.activeId && (
            <span style={{ position: 'relative' }}>
              <span role="img" aria-label="pointer" style={pointerStyle}>👈</span>
            </span>
          )}
        </TocLink>
        {heading.children &&
          <Toc toc={heading.children} activeId={this.props.activeId} level={level + 1} />}
      </Fragment>
    ))
  }
}

const getTocIds = toc => flatten(toc.map(heading => [heading.id, getTocIds(heading.children)]))

class ActiveToc extends Component {
  constructor ({ toc }) {
    super()
    this.state = {
      ids: getTocIds(toc),
      toc,
    }
  }
  render () {
    return (
      <ActiveContent idList={this.state.ids} offsetTop={62}>
        {activeId => <Toc toc={this.state.toc} activeId={activeId} level={0} />}
      </ActiveContent>
    )
  }
}

export default ActiveToc



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Toc.js